import React from "react";
import styled from "styled-components";
import logo from "./assets/logo.png";

const Loader = () => {
  return (
    <StyledWrapper>
      <div className="main-container">
        <div className="loader">
          <svg viewBox="0 0 800 500" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient id="chipGradient" x1={0} y1={0} x2={0} y2={1}>
                <stop offset="0%" stopColor="#2d2d2d" />
                <stop offset="100%" stopColor="#0f0f0f" />
              </linearGradient>
              <linearGradient id="textGradient" x1={0} y1={0} x2={0} y2={1}>
                <stop offset="0%" stopColor="#eeeeee" />
                <stop offset="100%" stopColor="#888888" />
              </linearGradient>
              <linearGradient id="pinGradient" x1={1} y1={0} x2={0} y2={0}>
                <stop offset="0%" stopColor="#bbbbbb" />
                <stop offset="50%" stopColor="#888888" />
                <stop offset="100%" stopColor="#555555" />
              </linearGradient>
            </defs>
            <g id="traces">
              <path d="M0 100 H240 V210 H560 V90 H800" className="trace-bg" />
              <path
                d="M0 100 H240 V210 H560 V90 H800"
                className="trace-flow purple"
              />
              <path d="M0 180 H220 V230 H580 V160 H800" className="trace-bg" />
              <path
                d="M0 180 H220 V230 H580 V160 H800"
                className="trace-flow blue"
              />
              <path d="M0 260 H200 V250 H600 H800" className="trace-bg" />
              <path
                d="M0 260 H200 V250 H600 H800"
                className="trace-flow yellow"
              />
              <path d="M0 350 H180 V270 H620 V340 H800" className="trace-bg" />
              <path
                d="M0 350 H180 V270 H620 V340 H800"
                className="trace-flow green"
              />
              <path d="M800 90 H560 V210 H240 V100 H0" className="trace-bg" />
              <path
                d="M800 90 H560 V210 H240 V100 H0"
                className="trace-flow white-line"
              />
              <path d="M800 160 H580 V230 H220 V180 H0" className="trace-bg" />
              <path
                d="M800 160 H580 V230 H220 V180 H0"
                className="trace-flow white-line"
              />
              <path d="M800 250 H600 V250 H200 V260 H0" className="trace-bg" />
              <path
                d="M800 250 H600 V250 H200 V260 H0"
                className="trace-flow white-line"
              />
              <path d="M800 340 H620 V270 H180 V350 H0" className="trace-bg" />
              <path
                d="M800 340 H620 V270 H180 V350 H0"
                className="trace-flow white-line"
              />
            </g>
            <text
              x={400}
              y={240}
              fontFamily="Arial, sans-serif"
              fontSize={22}
              fill="url(#textGradient)"
              textAnchor="middle"
              alignmentBaseline="middle"
            >
              ..
            </text>
            <circle cx={0} cy={100} r={5} fill="black" />
            <circle cx={0} cy={180} r={5} fill="black" />
            <circle cx={0} cy={260} r={5} fill="black" />
            <circle cx={0} cy={350} r={5} fill="black" />
            <circle cx={800} cy={90} r={5} fill="black" />
            <circle cx={800} cy={160} r={5} fill="black" />
            <circle cx={800} cy={250} r={5} fill="black" />
            <circle cx={800} cy={340} r={5} fill="black" />
          </svg>
        </div>
      </div>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  z-index: 1;
  height: auto;

  rotate: 0deg;
  width: 100%;
  overflow: hidden;

  @media (max-width: 500px) {
    rotate: 90deg;
    width: 300px;
    height: auto;
  }
  .main-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
  }

  .loader {
    width: 100%;
  }

  .trace-bg {
    stroke: #333;
    stroke-width: 1.8;
    fill: none;
  }

  .trace-flow {
    stroke-width: 1.8;
    fill: none;
    stroke-dasharray: 40 400;
    stroke-dashoffset: 438;
    filter: drop-shadow(0 0 6px currentColor);
    animation: flow 3s cubic-bezier(0.5, 0, 0.9, 1) infinite;
  }

  .yellow {
    stroke: #ffea00;
    color: #ffea00;
  }
  .blue {
    stroke: #00ccff;
    color: #00ccff;
  }
  .green {
    stroke: #00ff15;
    color: #00ff15;
  }
  .purple {
    stroke: #9900ff;
    color: #9900ff;
  }
  .red {
    stroke: #ff3300;
    color: #ff3300;
  }
  .white-line {
    stroke: #ffffff;
    color: #ffffff;
  }

  @keyframes flow {
    to {
      stroke-dashoffset: 0;
    }
  }

  /* Čip */
  .chip-body {
    rx: 20;
    ry: 20;
  }

  /* Text uvnitř čipu */
  .chip-text {
    font-weight: bold;
    letter-spacing: 1px;
  }

  /* Piny */
  .chip-pin {
    stroke: #444;
    stroke-width: 0.5;
    filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.6));
  }
`;

export default Loader;
